import { QUERIES } from "modules/common/query";
import { getQueryClient } from "modules/common/getQueryClient";

export const useReset = () => {
  const queryClient = getQueryClient();

  return {};

  async function resetUser() {
    await queryClient.resetQueries();
    await queryClient.resetQueries({
      queryKey: [QUERIES.DECK_USER],
    });
    await queryClient.resetQueries({
      queryKey: [QUERIES.COLLECTION_CARDS],
    });
    await queryClient.resetQueries({
      queryKey: [QUERIES.CARD_OWNERSHIP_STATUS],
    });
    await queryClient.resetQueries({ queryKey: [QUERIES.COLLECTION_FACETS] });
    await queryClient.resetQueries({
      queryKey: [QUERIES.COLLECTION_USER],
    });
  }
};
